import { render, staticRenderFns } from "./bssx.vue?vue&type=template&id=e9789a4c&scoped=true"
import script from "./bssx.vue?vue&type=script&lang=js"
export * from "./bssx.vue?vue&type=script&lang=js"
import style0 from "./bssx.vue?vue&type=style&index=0&id=e9789a4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9789a4c",
  null
  
)

export default component.exports